import { connect } from 'react-redux';

import { detectMobileDevice } from '../../../../util/detectBrowser';
import {
  getActiveTaskId,
  getTaskAddedByCopy,
} from '../../../../selectors/checklist/checklistSelectors';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import * as helpers from '../helpers';

import ChecklistTaskItem from './ChecklistTaskItem';

const mapStateToProps = (state, ownProps) => ({
  selectedTaskId: getActiveTaskId(state),
  addedByName: getTaskAddedByCopy(state, ownProps.taskId, ownProps.addedByUserId),
  isSponsoredLinkFromZola: ownProps.sponsoredUrl && !helpers.isSponsoredLink(ownProps.sponsoredUrl),
});

const mapDispatchToProps = dispatch => ({
  goToTask: taskId => dispatch(checklistV2Actions.goToChecklistTask(taskId)),
  completeTask: taskId =>
    dispatch(checklistV2Actions.toggleCompleted(taskId))
      .then(taskJson => {
        dispatch(checklistV2Actions.emitConfMsg(taskJson.completed_at));

        return taskJson;
      })
      .then(taskJson => {
        const isMobile = detectMobileDevice();

        if (!isMobile && taskJson.completed_at)
          dispatch(checklistV2Actions.handleGoToNextTask(taskJson.id));

        return taskJson;
      }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTaskItem);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskItem/index.js